import { Network, TokenSymbol } from '@nsfw-app/crypto'
import { getTokensForChainId } from 'config/tokens'
import { Contract } from 'ethers'
import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'

type RegistryKey = `${Network}-${TokenSymbol}`

export class ContractsRegistry {
  root: RootStore

  // Store initialised contracts with signer
  registry = new Map<RegistryKey, Contract>()

  constructor(root: RootStore) {
    this.root = root
    makeAutoObservable(this)
  }

  /**
   * Returns an ethers [Contract] instance for a given token
   */
  async getInstance(
    token: TokenSymbol,
    { chainId } = { chainId: this.root.injectedWallet.selectedNetwork.id }
  ): Promise<Contract> {
    const key = `${chainId}-${token}` as RegistryKey

    if (!this.registry.has(key)) {
      return this._registerContract({ key, token, chainId })
    }

    const contract = this.registry.get(key)
    if (!contract) throw new Error(`No contract found for [${key}]`)
    return contract
  }

  private _registerContract = async ({
    token,
    key,
    chainId
  }: {
    token: TokenSymbol
    key: RegistryKey
    chainId: Network
  }) => {
    const metadata = getTokensForChainId(chainId).find((n) => n.symbol === token)

    if (!metadata) {
      throw new Error(`No metadata found for token ${token}`)
    }

    const provider = await this.root.wallets.resolveProvider()
    console.log(metadata)

    // Initalise contract and save it to the registry
    const contract = new Contract(metadata.contract, metadata.abi, provider)
    this.registry.set(key, contract)
    return contract
  }
}
